"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stitchLink = void 0;
var getVal_1 = require("./getterSetterDeleter/getVal");
var stitchLink = function (_a) {
    /**
     * idPath: ['a','b']
     * desc -> here array means that both the items will be stitched one after the other as per config
     * now imagine a config like this -> idPath: ['a,c', b]
     * desc -> in this case, the a,c will be parsed such that the first truthy value found for
     * either of the paths, will be considered for ary index 0
     *
     * config.target = '_blank' : this will prepare the full url including hostname & port so that on the outside we can open in new tab
     */
    var data = _a.data, config = _a.config;
    var idPath = config.idPath, _b = config.idAs, idAs = _b === void 0 ? 'query' : _b, idName = config.idName, urlString = config.urlString, suffix = config.suffix, target = config.target;
    var isArray = Array.isArray(idPath);
    var idString = "";
    var splitTrim = function (str) { return str.split(",").map(function (d) { return d.trim(); }); };
    if (isArray) {
        var ids_1 = idPath.map(function (p) { return (0, getVal_1.getVal)(data, splitTrim(p)); });
        //if any of the paths gives falsy value then return undefined
        if (ids_1.some(function (id) { return !!id === false; }))
            return undefined;
        idAs.map(function (as, i) {
            if (as === "param") {
                ids_1[i] = "/" + ids_1[i];
            }
            else if (as === "query") {
                ids_1[i] = "?".concat(idName ? idName[i] : "id", "=").concat(ids_1[i]);
            }
        });
        idString = ids_1.join("");
    }
    else {
        var id = (0, getVal_1.getVal)(data, splitTrim(idPath));
        if (!id)
            return undefined;
        idString =
            idAs === "query"
                ? "?".concat(idName || "id", "=").concat(id)
                : idAs === "param"
                    ? "/".concat(id)
                    : id;
    }
    var hostAndPort = target === "_blank" ? window.location.origin : "";
    return "".concat(hostAndPort).concat(urlString).concat(idString).concat(suffix || "");
};
exports.stitchLink = stitchLink;
